// extracted by mini-css-extract-plugin
export var labelWrapper = "_gz-0";